const formatDate = (dateString: string) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const getLevelStyle = (level: string) => {
  if (!level)
    return {
      bg: "bg-gray-100",
      text: "text-gray-600",
      border: "border-gray-200",
    };

  const l = level.toUpperCase();
  if (l === "PROFICIENT")
    return {
      bg: "bg-green-100",
      text: "text-green-700",
      border: "border-green-200",
    }; // Green Success
  if (l === "INDEPENDENT")
    return {
      bg: "bg-yellow-50",
      text: "text-[#C4A603]",
      border: "border-[#C4A603]/30",
    }; // Gold Yellow
  return { bg: "bg-red-50", text: "text-red-600", border: "border-red-200" }; // Red Basic
};

export { formatDate, getLevelStyle };
